import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import Services from "@/components/landing/Services";
import WhyEngage from "@/components/landing/WhyEngage";
import QuoteBand from "@/components/landing/QuoteBand";
import AboutJames from "@/components/landing/AboutJames";
import TrackRecord from "@/components/landing/TrackRecord";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#02060D] text-slate-100 selection:bg-teal-300 selection:text-[#02060D]">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <WhyEngage />
        <QuoteBand />
        <AboutJames />
        <TrackRecord />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
